import { render, staticRenderFns } from "./GroupItem.vue?vue&type=template&id=716bec8e&scoped=true"
import script from "./GroupItem.vue?vue&type=script&lang=js"
export * from "./GroupItem.vue?vue&type=script&lang=js"
import style0 from "./GroupItem.vue?vue&type=style&index=0&id=716bec8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716bec8e",
  null
  
)

export default component.exports